module.exports = __webpack_public_path__ + "static/media/eAppPlaceholder.ff324170.svg";